var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9C1.5 8.58579 1.83579 8.25 2.25 8.25H6.75C7.16421 8.25 7.5 8.58579 7.5 9V15.75C7.5 16.1642 7.16421 16.5 6.75 16.5H2.25C1.83579 16.5 1.5 16.1642 1.5 15.75V9ZM3 9.75V15H6V9.75H3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12C9 11.5858 9.33579 11.25 9.75 11.25H14.25C14.6642 11.25 15 11.5858 15 12V18.75C15 19.1642 14.6642 19.5 14.25 19.5H9.75C9.33579 19.5 9 19.1642 9 18.75V12ZM10.5 12.75V18H13.5V12.75H10.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 3.75C16.5 3.33579 16.8358 3 17.25 3H21.75C22.1642 3 22.5 3.33579 22.5 3.75V15.75C22.5 16.1642 22.1642 16.5 21.75 16.5H17.25C16.8358 16.5 16.5 16.1642 16.5 15.75V3.75ZM18 4.5V15H21V4.5H18Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 6C4.91421 6 5.25 6.33579 5.25 6.75V9C5.25 9.41421 4.91421 9.75 4.5 9.75C4.08579 9.75 3.75 9.41421 3.75 9V6.75C3.75 6.33579 4.08579 6 4.5 6Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 15C4.91421 15 5.25 15.3358 5.25 15.75V18C5.25 18.4142 4.91421 18.75 4.5 18.75C4.08579 18.75 3.75 18.4142 3.75 18V15.75C3.75 15.3358 4.08579 15 4.5 15Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9C12.4142 9 12.75 9.33579 12.75 9.75V12C12.75 12.4142 12.4142 12.75 12 12.75C11.5858 12.75 11.25 12.4142 11.25 12V9.75C11.25 9.33579 11.5858 9 12 9Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 0.75C19.9142 0.75 20.25 1.08579 20.25 1.5V3.75C20.25 4.16421 19.9142 4.5 19.5 4.5C19.0858 4.5 18.75 4.16421 18.75 3.75V1.5C18.75 1.08579 19.0858 0.75 19.5 0.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 15C19.9142 15 20.25 15.3358 20.25 15.75V18C20.25 18.4142 19.9142 18.75 19.5 18.75C19.0858 18.75 18.75 18.4142 18.75 18V15.75C18.75 15.3358 19.0858 15 19.5 15Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18C12.4142 18 12.75 18.3358 12.75 18.75V21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21V18.75C11.25 18.3358 11.5858 18 12 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandles);
export default __webpack_public_path__ + "static/media/candles.200d14fa0b2833afccce7326d0fb8b3d.svg";
export { ForwardRef as ReactComponent };